export default __webpack_public_path__ + "static/media/foot-left.7a9f9d8e.svg";